module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"drag_and_drop_the":"Drag and drop the","icon_to_rearrange":"icon to rearrange the categories"},"id":{"drag_and_drop_the":"tarik dan letakkan","icon_to_rearrange":"ikon untuk mengurutkan kategori"}}')
  delete Component.options._Ctor
}
